import { useState } from 'react';
import styles from './styles.module.scss';

type EditableTextProps = {
    texto: string;
    id?: string;
    onClick?: any;
    onSave : any;
    isLogicMaker: boolean;
    css?: any;

};

export default function EditableText({ texto, id, onSave, onClick,isLogicMaker,css } : EditableTextProps) {
    const [isEditing, setIsEditing] = useState(false);
    const [currentText, setCurrentText] = useState(texto);
    const [oneClick, setoneClick] = useState(false);
    

    function handleSave() {
        setIsEditing(false);
        onSave(currentText); // Atualiza JSON
    }

    return (
        <div className="editable-text" style={{margin: '0px',height: '100%', width: '100%'}} >
            {isEditing ? 
                <textarea
                    className={styles.input}
                    value={currentText}
                    onChange={(e) => setCurrentText(e.target.value)}
                    onBlur={handleSave}
                    onFocus={()=>{setCurrentText(texto)}}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSave();
                    }}
                    style={{
                        position: 'relative',
                        width: isLogicMaker? '100%': '8vw',
                        height: isLogicMaker?'100%': '8vw',
                        ...css
                

                    }}
                
                    autoFocus
                />
             : 
                <div
                    id={id}
                    className={styles.texto}
                    onClick={(e) => {
                        e.stopPropagation();
                        setoneClick(true);
                        setTimeout(() => {
                                setoneClick(false)
                        }, 1000);
                        if(oneClick) {
                            setIsEditing(true);
                        }
                        onClick(); // Sua função de selecionar elemento
                    }}
                    style={{
                        position: 'relative',
                        cursor: 'move',
                        width: isLogicMaker? '100%': '8vw',
                        height: isLogicMaker?'100%': '8vw',
                        ...css,
                        
                
                        
                    }}
                >
                    {texto}
                    </div>
            }
        </div>
    );
}
